import { jsx as _jsx } from "react/jsx-runtime";
import { ResourceModalForm } from '../EntityModalForms/ResourceModalForm';
import './EditResourceModal.scss';
function EditResourceModal({ isOpen, onClose, onUpdate, resource, isLoading }) {
    return (_jsx(ResourceModalForm, { isOpen: isOpen, onClose: onClose, onSubmit: onUpdate, isLoading: isLoading, mode: "edit", resource: resource, title: "Edit Resource", submitIdleLabel: "Update Resource", submitBusyLabel: "Updating..." }));
}
export default EditResourceModal;
